module.exports = __webpack_public_path__ + "static/media/img-welcome.62f24abf.png";